import { GridLogicOperator } from "../../../models/gridFilterItem.es.js";
const getDefaultGridFilterModel = () => ({
  items: [],
  logicOperator: GridLogicOperator.And,
  quickFilterValues: [],
  quickFilterLogicOperator: GridLogicOperator.And
});
export {
  getDefaultGridFilterModel
};
//# sourceMappingURL=gridFilterState.es.js.map
